export type Locale = "el" | "en" | "ru" | "sr" | "ro" | "bg" | "mk";

export const locales: Locale[] = ["el", "en", "ru", "sr", "ro", "bg", "mk"];

export const DEFAULT_LOCALE: Locale = "el";

export function isLocale(x: string): x is Locale {
  return (locales as string[]).includes(x);
}
